export interface ColorOption {
  label: string;
  class: string;
  hex: string;
  disabled?: boolean; // Optional property to indicate if the color is disabled
}

export const COLOR_OPTIONS: ColorOption[] = [
  { label: 'Green', class: 'status-green', hex: '#388e3c', disabled: true },
  { label: 'Orange', class: 'status-orange', hex: '#f9a825', disabled: false },
  { label: 'Red', class: 'status-red', hex: '#c62828', disabled: true },
  { label: 'Blue', class: 'status-blue', hex: '#1976d2', disabled: false },
  { label: 'Purple', class: 'status-purple', hex: '#6a1b9a', disabled: false },
  { label: 'Gray', class: 'status-gray', hex: '#616161', disabled: false },
  { label: 'Yellow', class: 'status-yellow', hex: '#fbc02d', disabled: false },
  { label: 'Teal', class: 'status-teal', hex: '#00796b', disabled: false },
  { label: 'Pink', class: 'status-pink', hex: '#d81b60', disabled: false },
  { label: 'Brown', class: 'status-brown', hex: '#5d4037', disabled: false },
  { label: 'Light Blue', class: 'status-light-blue', hex: '#039be5', disabled: false },
  { label: 'Light Gray', class: 'status-light-gray', hex: '#bdbdbd', disabled: false },
  { label: 'Light Purple', class: 'status-light-purple', hex: '#ab47bc', disabled: false },
  { label: 'Light Orange', class: 'status-light-orange', hex: '#ffa726', disabled: false },
  { label: 'Light Yellow', class: 'status-light-yellow', hex: '#ffeb3b', disabled: false },
  { label: 'Light Teal', class: 'status-light-teal', hex: '#26a69a', disabled: false },
  { label: 'Light Pink', class: 'status-light-pink', hex: '#f06292', disabled: false },
  { label: 'Light Brown', class: 'status-light-brown', hex: '#8d6e63', disabled: false }
];
